import React from 'react'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import LineLockOpenAltIcon from 'components/Luxkit/Icons/line/LineLockOpenAltIcon'
import LineGiftIcon from 'components/Luxkit/Icons/line/LineGiftIcon'

interface IStepsHowItWorks {
  icon: React.ReactElement,
  title: string,
  description: string
}

interface IBurnOptions {
  image: string,
  title: string,
  caption: string,
  description: string,
  buttonText: string,
}

export const StepsHowItWorks: Array<IStepsHowItWorks> = [
  {
    icon: <LineLockOpenAltIcon size="XL" />,
    title: '1. Unlock our VIP escapes',
    description: 'Enjoy unbeatable value with added extras',
  },
  {
    icon: <LineClockDollarIcon size="XL" />,
    title: '2. Choose your offer',
    description: 'Decide on your destination',
  },
  {
    icon: <LineGiftIcon size="XL" />,
    title: '3. Use your Velocity Points',
    description: 'Pay as normal or use Velocity Points on eligible offers',
  },
]

export const BurnOptions: Array<IBurnOptions> = [
  {
    image: 'velocityBurnImageV3',
    title: 'Use your Velocity Points',
    caption: 'towards your next escape',
    description: 'Choose to use Points towards all or part of your eligible offer (a minimum of 5,000 Points required). You\'ll need your Frequent Flyer membership details on hand.',
    buttonText: 'Redeem Velocity Points',
  },
]
